import { QueryKeys } from '../../utils/queryKeys';

export const inclusiveEducationContentKeys = {
    all: [QueryKeys.GET_INCLUSIVE_EDUCATION_CONTENT],
    getInclusiveEducationContentKeys: () => [...inclusiveEducationContentKeys.all],
};